import Phaser from "phaser";
import { ModalLayer } from "@yjsgames/phaser-ui";
import { PALETTE_NUM } from "../themes/palette.js";

export interface BlockingLoadingOverlayOptions {
  readonly screenWidth: number;
  readonly screenHeight: number;
}

/**
 * 외부 SDK/스토어 응답 대기용 전체화면 overlay.
 * dim overlay가 입력을 차단하고, closeOnBackdrop=false라 사용자가 닫을 수 없다.
 */
export class BlockingLoadingOverlay extends ModalLayer {
  private readonly spinner: Phaser.GameObjects.Graphics;

  constructor(scene: Phaser.Scene, opts: BlockingLoadingOverlayOptions) {
    super(scene, {
      screenWidth: opts.screenWidth,
      screenHeight: opts.screenHeight,
      overlayAlpha: 0.72,
      closeOnBackdrop: false,
    });

    const cx = opts.screenWidth / 2;
    const cy = opts.screenHeight / 2;

    this.spinner = scene.add.graphics({ x: cx, y: cy - 12 });
    this.spinner.lineStyle(5, PALETTE_NUM.textBright, 0.92);
    this.spinner.beginPath();
    this.spinner.arc(0, 0, 22, Phaser.Math.DegToRad(-50), Phaser.Math.DegToRad(250), false);
    this.spinner.strokePath();

    this.contentContainer.add(this.spinner);
  }

  override open(): void {
    super.open();
    this.scene.tweens.add({
      targets: this.spinner,
      angle: 360,
      duration: 900,
      repeat: -1,
    });
  }

  override close(): void {
    this.scene.tweens.killTweensOf(this.spinner);
    super.close();
  }

  override destroy(fromScene?: boolean): void {
    this.scene.tweens.killTweensOf(this.spinner);
    super.destroy(fromScene);
  }
}
